var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmapMap',{style:({
    width: '100%',
    height: _vm.xsOnly ? '300px' : '450px',
    'border-radius': _vm.smAndDown ? '0' : '8px',
    overflow: 'hidden',
  }),attrs:{"center":_vm.center,"zoom":12,"map-type-id":"satellite"}},[_vm._l((_vm.coordinates),function(item,index){return _c('GmapPolygon',{key:index,attrs:{"paths":_vm.convertCoordinates(item.coordinates),"options":_vm.polygonOptions}})}),_c('GmapPolygon',{attrs:{"paths":_vm.polygonPath,"options":_vm.polygonOptions}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }